import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import { baseUrl } from 'scripts/env';
import axios from 'axios'

const REDUCER = 'vox_payments'
const NS = `@@${REDUCER}/`

export const fetchRequest = createAction(`${NS}FETCH_REQUEST`)
export const fetchSuccess = createAction(`${NS}FETCH_SUCCESS`)
export const fetchFailure = createAction(`${NS}FETCH_FAILURE`)

const initialState = {
    isLoading: false,
    items: [],
    pagination: {
        current: 1,
        pageSize: 20,
        defaultPageSize: 20,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200']
    },
}

export const fetch = input => async (dispatch) => {
    dispatch(fetchRequest())
    const params = _.mapValues(input, (value) => { return _.isArray(value) ? value[0] : value })
    const response = await axios({
        url: `${baseUrl}/${REDUCER}`,
        params
    });
  
    const pagination = _.get(response, 'data.pagination', false)
    const items = _.get(response, `data.${REDUCER}`, false)
    if (items === false || pagination === false) {
        dispatch(fetchFailure())
        return false
    }
    
    dispatch(fetchSuccess({items, pagination}))
    return true
}

export default createReducer(
  {
    [fetchRequest]: (state) => ({ ...state, isLoading : true }),
    [fetchSuccess]: (state, data) => { 
        const items = data.items;
        const pagination = Object.assign(
            {}, 
            state.pagination, 
            _.mapKeys(data.pagination, (value, key) => { return _.camelCase(key) })
        );
        return { ...state, items, pagination, isLoading: false }
    },
    [fetchFailure]: (state, error) => ({ ...state, isLoading : false }),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/vox_payments.js